import React, { createContext, useContext, useState } from 'react';

import useWindowResize from '../hooks/useWindowResize';
import { breakpoints } from '../themes/mainTheme';

export type DevicesT = {
  isDesktop: boolean;
  isTablet: boolean;
  isMobile: boolean;
};

type ResponsiveProviderPropsT = {
  children: React.ReactElement | React.ReactElement[];
};

const defaultValue: DevicesT = {
  isDesktop: true,
  isTablet: false,
  isMobile: false,
};

const ResponsiveCtx = createContext<DevicesT>(defaultValue);

const ResponsiveProvider: React.FC<ResponsiveProviderPropsT> = ({ children }) => {
  const [devices, setDevices] = useState<DevicesT>(defaultValue);

  let width = 0;
  const checkDevices = () => {
    width = window.innerWidth;

    setDevices({
      isDesktop: width >= breakpoints.desktop,
      isTablet: width < breakpoints.desktop && width >= breakpoints.tablet,
      isMobile: width < breakpoints.tablet,
    });
  };

  useWindowResize(checkDevices, true, 100);

  return <ResponsiveCtx.Provider value={devices}>{children}</ResponsiveCtx.Provider>;
};

export default ResponsiveProvider;

export const useResponsive = (): DevicesT => useContext(ResponsiveCtx);
